// extracted by mini-css-extract-plugin
export default {"container":"style_container__YxV5a","tag":"style_tag__Lubk2","host":"style_host__LLc9F","name":"style_name__U3UVn","tool":"style_tool__CgGld"};